import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import DetailPage from "../pages/detail/page";
import NewsPage from "../pages/news/page";
import SearchPage from "../pages/search/page";
import AboutPage from "../pages/about/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/category/:type", element: <CategoryPage /> },
      { path: "/detail/:id", element: <DetailPage /> },
      { path: "/news", element: <NewsPage /> },
      { path: "/search", element: <SearchPage /> },
      { path: "/about", element: <AboutPage /> },
      { path: "/404", element: <NotFound /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;